import classNames from "classnames/bind";
import type { ResolvedReview } from "resolvers/data/trustpilotResolver";

import ReviewCard from "../ReviewCard";
import styles from "./ReviewsWrapper.module.scss";

export interface ReviewsWrapperProps {
    reviews: ResolvedReview[];
    date: string;
}

const cx = classNames.bind(styles);

const ReviewsWrapper = ({ reviews, date }: ReviewsWrapperProps) => {
    return (
        <div className={cx("container")}>
            <h3 className={cx("date")}>Submitted on: {date}</h3>
            {reviews.map((item, i) => (
                <ReviewCard {...item} key={item.id} />
            ))}
        </div>
    );
};

export default ReviewsWrapper;
